import { useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { KeenIcon, DefaultTooltip, LazyFormikSelect, RichTextEditorFormik } from '@/components';
import { useLazyOptions } from '@/hooks';
import { toast } from 'sonner';
import taxService from '@/services/billing/taxService';

const TemplateSetup = () => {
    const [dataLoading, setDataLoading] = useState(false);
    const [itemData, setItemData] = useState([])
    
    return (
        <>
        <div className='flex items-center my-5'>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            <p className='text-sm px-4'>Setup</p>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
        </div>
        <div className='flex items-start lg:flex-nowrap flex-wrap gap-5'>
            <div className='lg:w-1/2 w-full'>
                <div className="space-y-5">
                    <div className='flex items-center'>
                        <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                        <p className='text-sm'>Basic Information</p>
                    </div>
                    <div className='flex items-center gap-5'>
                        <div className='w-full'>
                            <label className="form-label mb-1">Name <span className='pl-px text-red-600'>*</span></label>
                            <Field className="input" type="text" name={`invoice_template.name`} />
                            <ErrorMessage
                                name={`invoice_template.name`}
                                component="div"
                                className="text-red-500 text-xs mt-1"
                            />
                        </div>
                        {/* <div className='w-full'>
                            <label className="form-label mb-1">Notes Position on Invoice</label>
                            <Field as="select" className="input" name="invoice_template_settings.base_settings.notes_position_on_invoice">
                                <option value="top">Top</option>
                                <option value="bottom">Bottom</option>
                            </Field>
                        </div> */}
                    </div>
                    <Field name={`invoice_template.is_default`}>
                        {({ field, form }) => (
                            <label className="switch w-fit">
                            <span className="switch-label">Default Template For All Invoices</span>
                            <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => form.setFieldValue(`invoice_template.is_default`, !field.value)}
                            />
                            </label>
                        )}
                    </Field>
                </div>
                {/* <div className="space-y-5 mt-8">
                    <div className='flex items-center'>
                        <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                        <p className='text-sm'>Date Information</p>
                    </div>
                    <div className='flex items-center gap-5'>
                        <div className='w-full'>
                            <label className="form-label mb-1">Due Date</label>
                            <Field className="input no-spinner" type="number" name={`invoice_template_settings.base_settings.default_due_date`} />
                        </div>
                        <div className='w-full'>
                            <label className="form-label mb-1">Due Date Type</label>
                            <Field as="select" className="input" name="invoice_template_settings.base_settings.default_due_date_label">
                                <option value="days after invoice date">Days After Invoice Date</option>
                                <option value="of current month">Of The Current Month</option>
                                <option value="of following month">Of The Following Month</option>
                            </Field>
                        </div>
                    </div>
                </div> */}
                {/* <div className="space-y-5 mt-8">
                    <div className='flex items-center'>
                        <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                        <p className='text-sm'>Tax Information</p>
                    </div>
                    <div className='flex items-center gap-5'>
                        <div className='w-full'>
                            <label className="form-label mb-1.5 pl-1.5">Default Tax 1</label>
                            <LazyFormikSelect
                                name={`tax1`}
                                options={taxOptions}
                                placeholder="Select Tax "
                                onFocus={() => loadTax(null)}
                                isLoading={taxLoading}
                                // preloadedOption={values.tax[0].item}
                            />
                            <ErrorMessage
                                name={`tax1`}
                                component="div"
                                className="text-red-500 text-xs mt-1"
                            />
                        </div>
                        <div className='w-full'>
                            <label className="form-label mb-1.5 pl-1.5">Default Tax 2</label>
                            <LazyFormikSelect
                                name={`tax2`}
                                options={taxOptions}
                                placeholder="Select Tax "
                                onFocus={() => loadTax(null)}
                                isLoading={taxLoading}
                                // preloadedOption={values.tax[0].item}
                            />
                            <ErrorMessage
                                name={`tax2`}
                                component="div"
                                className="text-red-500 text-xs mt-1"
                            />
                        </div>
                    </div>
                </div> */}
            </div>
            <div className='lg:w-1/2 w-full space-y-5'>
                <div className=''>
                    <DefaultTooltip title='This is the note that will be displayed on the invoice' placement="bottom" className="max-w-full">
                        <label className="w-fit form-label items-center gap-1 mb-1">
                            <KeenIcon icon="information" />
                            <p className='text-sm'>Note</p>
                        </label>
                    </DefaultTooltip>
                        
                    <div>
                        <Field name="invoice_template_settings.invoice.notes" component={RichTextEditorFormik} />
                    </div>
                </div>
                <div className=''>
                    <label className="form-label mb-1">Terms & Conditions</label>
                    <div>
                        <Field name="invoice_template_settings.invoice.terms_and_conditions" component={RichTextEditorFormik} />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export { TemplateSetup }